import { render, staticRenderFns } from "./queryform3.vue?vue&type=template&id=98acacb6&scoped=true&"
import script from "./queryform3.vue?vue&type=script&lang=js&"
export * from "./queryform3.vue?vue&type=script&lang=js&"
import style0 from "./queryform3.vue?vue&type=style&index=0&id=98acacb6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98acacb6",
  null
  
)

export default component.exports